import './color_key_component.scss'
import { Controller } from 'stimulus'
import { uniqBy, sortBy } from 'lodash'

export default class extends Controller {
  static targets = ['colors']

  connect = (): void => {
    this.loadColorKey()
  }

  loadColorKey = (): void => {
    if (globalThis._CONFIGURATION_ === undefined || globalThis._CONFIGURATION_.colorKey === undefined) return
    const nodes = sortBy(uniqBy(Object.values(globalThis._CONFIGURATION_.colorKey).map(nodeTypeId => Object.values(nodeTypeId)).flat(), 'color'), 'name')
    this.colorsTarget.innerHTML = ''
    nodes.forEach(node => this.attachColor(node))
  }

  attachColor = (node: object): void => {
    if (node.count === 0) return
    this.colorsTarget.appendChild(this.createColorElement(String(node.color), String(node.name), node.count.toString()))
  }

  createColorElement = (color: string, name: string, count: string): object => {
    const parent: object = document.createElement('div')
    const swatch: object = document.createElement('span')
    const text: object = document.createElement('span')
    parent.className = 'color_key-color'
    swatch.className = 'color_key-swatch'
    text.className = 'color_key-text'
    swatch.setAttribute('style', `background-color: ${color};`)
    text.innerHTML = `${name}: ${count}`
    parent.appendChild(swatch)
    parent.appendChild(text)
    return parent
  }
}
